import styled, { css } from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const InfoIconWrapper = styled.span`
	visibility: hidden;
	position: absolute;
	top: 10px;
	left: 8px;
	height: 16px;
	width: 16px;
	cursor: pointer;

	svg {
		transition: none;

		&:hover {
			fill: ${colors.grey6};
		}
	}
`;

export const Cell = styled.div`
	position: relative;
	color: ${colors.grey8};
	min-width: 156px;
	display: flex;
	align-items: center;
	font-size: 13px;
	letter-spacing: 0.3px;
	line-height: 19px;
	border-right: 1px solid ${colors.grey2};
	height: 36px;
	padding: 0 12px;

	&:first-child {
		padding-left: 32px;
	}

	${({ noBorder }) => noBorder && 'border-right:none;'};
`;

export const Row = styled.div`
	display: grid;
	grid-template-columns: 300px;
	grid-auto-flow: column;
	width: fit-content;

	${({ selected }) => selected && `background-color: ${colors.green0}`};

	${({ isFaded }) => isFaded && 'opacity:0.2;'};

	${({ isGroup }) =>
		isGroup &&
		css`
			${Cell} {
				height: 48px;
				padding-top: 12px;
				font-weight: 500;
			}

			${Text} {
				font-size: 16px;
			}

			${InfoIconWrapper} {
				top: 22px;
			}
		`};

	&:hover {
		${InfoIconWrapper} {
			visibility: visible;
		}
	}
`;

export const CellNumber = styled(Cell)`
	justify-content: center;
`;

export const CellCheckbox = styled(Cell)`
	min-width: 168px;
`;

export const NumberText = styled.div`
	width: 100%;
	justify-content: center;
	display: flex;
`;

export const Text = styled.div`
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
`;

export const LevelText = styled.span`
	font-size: 16px;
	font-weight: 400;
	color: ${colors.grey5};
`;
